import { render } from "./ClientManage.vue?vue&type=template&id=306f5032&scoped=true"
import script from "./ClientManage.vue?vue&type=script&lang=js"
export * from "./ClientManage.vue?vue&type=script&lang=js"

import "./ClientManage.vue?vue&type=style&index=0&id=306f5032&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306f5032"]])

export default __exports__